export default "__VITE_ASSET__HlKbgFvo__"